import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function getLastAccessDate(date?: string | Date) {
  if (!date) {
    return '-';
  }

  const datePlus3UTC = new Date(new Date(date).getTime() + 3 * 60 * 60 * 1000);

  const formattedDate = format(datePlus3UTC, 'dd/MM/yyyy HH:mm', {
    locale: ptBR,
  });

  return formattedDate;
}
